import { useState, useEffect } from 'react';

export const useInfiniteSwiperSlides = (allItems, batchSize) => {
	const [items, setItems] = useState(() => allItems.slice(0, batchSize));
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		// обновляем только если реально изменился набор элементов
		setItems(prev => {
			const next = allItems.slice(0, batchSize);
			if (prev.length === next.length && prev.every((el, i) => el.id === next[i]?.id)) {
				return prev; // не обновляем, чтобы избежать цикла
			}
			return next;
		});
	}, [allItems, batchSize]);

	const loadMore = () => {
		if (loading) return;
		setLoading(true);

		setTimeout(() => {
			setItems(prev => {
				const nextItems = allItems.slice(0, prev.length + batchSize);
				return nextItems;
			});
			setLoading(false);
		}, 0);
	};

	return { items, loading, loadMore };
};
